export default [
  {
    header: "Accommodations",
  },
  {
    icon: "HomeIcon",
    title: "Accommodations",
    route: "foravila-accommodations-list",
  },
];
